import React from "react";
import "./Testimonials.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Services.css";
import Test1 from '../../assets/imgs/1-2-1.webp';
import Test2 from '../../assets/imgs/2-2-1.webp';
import Test3 from '../../assets/imgs/3-1-1.webp';
import Test4 from '../../assets/imgs/4-1-1.webp';
import Test5 from '../../assets/imgs/5-1-1.webp';
import Test6 from '../../assets/imgs/6-1-1.webp';
import Test7 from '../../assets/imgs/7-1.webp';
import Test8 from '../../assets/imgs/8-1.webp';
import Test9 from '../../assets/imgs/9-1.webp';
import Test10 from '../../assets/imgs/10-1.webp';

const Testimonials = () => {
    const settings = {
        arrows: false,
        dots: false,
        pauseOnHover: false,
        infinite: true,
        speed: 8000,
        autoplaySpeed: 8000,
        cssEase: "linear",
        autoplay: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1150,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 780,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]

    };


    return (
        <div className="testimonials-wrapper">
            <div className="testimonials-container">

                <Slider {...settings} >
                    <div className="testimonials-item">
                        <img src={Test1} alt="imagem de depoimentos"></img>
                    </div>
                    <div className="testimonials-item">
                        <img src={Test2} alt="imagem de depoimentos"></img>
                    </div>
                    <div className="testimonials-item">
                        <img src={Test3} alt="imagem de depoimentos"></img>
                    </div>
                    <div className="testimonials-item">
                        <img src={Test4} alt="imagem de depoimentos"></img>
                    </div>
                    <div className="testimonials-item">
                        <img src={Test5} alt="imagem de depoimentos"></img>
                    </div>
                    <div className="testimonials-item">
                        <img src={Test6} alt="imagem de depoimentos"></img>
                    </div>
                    <div className="testimonials-item">
                        <img src={Test7} alt="imagem de depoimentos"></img>
                    </div>
                    <div className="testimonials-item">
                        <img src={Test8} alt="imagem de depoimentos"></img>
                    </div>
                    <div className="testimonials-item">
                        <img src={Test9} alt="imagem de depoimentos"></img>
                    </div>
                    <div className="testimonials-item">
                        <img src={Test10} alt="imagem de depoimentos"></img>
                    </div>

                </Slider>
            </div>

        </div>
    );
};

export default Testimonials;
